import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MaterialPrice} from '../../classes/materialprice.class';
import {DecorationPrice} from '../../classes/decorationprice.class';
import {ExtraCostPrice} from '../../classes/extracostprice.class';
import {MatSlider, MatSliderThumb} from "@angular/material/slider";
import {FormsModule} from "@angular/forms";
import {MatError, MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {DecimalInputDirective} from "../../directives/decimal-input.directive";
import {MatIconModule} from "@angular/material/icon";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-price-indexation-dialog',
    templateUrl: './price-indexation-dialog.component.html',
    styleUrls: ['./price-indexation-dialog.component.scss'],
    imports: [
        MatDialogClose,
        MatSlider,
        FormsModule,
        MatFormField,
        DecimalInputDirective,
        MatLabel,
        MatError,
        MatInput,
        MatButton,
        MatSliderThumb,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatSuffix,
        MatIconModule
    ]
})
export class PriceIndexationDialogComponent implements OnInit {

    precent = 0;

    constructor(
        public dialogRef: MatDialogRef<PriceIndexationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public prices: {
            materialPrices: MaterialPrice[],
            decorationPrices: DecorationPrice[],
            extraCostPrices: ExtraCostPrice[]
        }
    ) {
    }

    ngOnInit(): void {

    }

    formatLabel = (value: number): string => {
        return `${value}%`;
    };

    apply() {
        const index = (100 + this.precent) / 100;
        this.prices.materialPrices.forEach(p => {
            p.price = Math.round((p.price * index) * 100) / 100;
        });
        this.prices.decorationPrices.forEach(p => {
            p.price = Math.round((p.price * index) * 100) / 100;
        });
        this.prices.extraCostPrices.forEach(p => {
            p.price = Math.round((p.price * index) * 100) / 100;
        });
        this.dialogRef.close();
    }

}
